import React__default from 'react';
import classnames from 'classnames';
import { Card, Price, AccordionItem, MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useLineItemSlots } from '../../slots/context.js';
import { Discount } from '../../components/Discount/Discount.js';
import { PrescriptionSection } from '../../components/PrescriptionSection/PrescriptionSection.js';
import { CardGlassesConfiguration } from '../../components/CardGlassesConfiguration/CardGlassesConfiguration.js';

const LineItemCard = ({ children , billingFrequency , bundleChildLineItems , currency , discountPrice , labels , price , quantity , subtitle , title , relativeDiscount , compactCard , imagePath , imageHref , imageAlt ='' , mini =false , hideDiscountSection =true  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    let priceDetail = null;
    const { getLabel  } = useIntl();
    const { Slots  } = useLineItemSlots();
    if (billingFrequency) {
        priceDetail = `/ ${billingFrequency}`;
    } else if (discountPrice) {
        priceDetail = /*#__PURE__*/ React__default.createElement(Price, {
            type: "strikethrough",
            value: price,
            size: "small",
            currency: currency
        });
    }
    const discountLabel = {
        discount: getLabel('cart.item.discount')
    };
    return /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card, {
        className: "line-item-card",
        layout: !mini && (isPhone || compactCard) ? 'vertical' : 'horizontal',
        key: title
    }, /*#__PURE__*/ React__default.createElement(Card.Image, {
        imageHref: imageHref,
        alt: imageAlt,
        backgroundColor: "var(--color--shade-lightest)",
        className: classnames('line-item-card__image', {
            'card-base__image--mini': mini
        }),
        src: imagePath
    }), /*#__PURE__*/ React__default.createElement(Card.Content, {
        childrenWrapperClassName: classnames('line-item-card__wrapper', {
            'line-item-card__wrapper--regular': !compactCard,
            'line-item-card__wrapper--mini': mini
        })
    }, /*#__PURE__*/ React__default.createElement(Card.Section, {
        className: classnames('line-item-card__details', {
            'line-item-card__details--compact': isPhone || compactCard
        })
    }, /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, title ? /*#__PURE__*/ React__default.createElement(Card.Heading, {
        variant: "subheading1"
    }, title) : null), subtitle ? /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        flex: true,
        className: "line-item-card__subtitle"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, subtitle)) : null, !Slots.QuantitySelector && /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "s"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, quantity))), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__price"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, /*#__PURE__*/ React__default.createElement(Price, {
        value: discountPrice ? discountPrice : price,
        size: "small",
        currency: currency
    }))), /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, priceDetail), !hideDiscountSection && discountPrice ? /*#__PURE__*/ React__default.createElement(Card.Text, null, /*#__PURE__*/ React__default.createElement(Discount, {
        absoluteValue: price - discountPrice,
        relativeValue: relativeDiscount,
        currency: currency,
        labels: discountLabel
    })) : null), Slots.QuantitySelector || Slots.StockAndDelivery ? /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__action"
    }, Slots.QuantitySelector && /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__quantity"
    }, /*#__PURE__*/ React__default.createElement(Slots.QuantitySelector, null)), Slots.StockAndDelivery && /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__stock"
    }, /*#__PURE__*/ React__default.createElement(Slots.StockAndDelivery, null))) : null), (bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.length) || children ? /*#__PURE__*/ React__default.createElement(Card.Section, null, children ? /*#__PURE__*/ React__default.createElement(PrescriptionSection, {
        children: children,
        labels: labels
    }) : null, (bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.length) ? /*#__PURE__*/ React__default.createElement(AccordionItem, {
        variant: "narrow",
        label: labels.configuration,
        id: labels.configuration
    }, /*#__PURE__*/ React__default.createElement(CardGlassesConfiguration, {
        bundleChildLineItems: bundleChildLineItems
    })) : null) : null, Slots.Reorder ? /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__reorder"
    }, /*#__PURE__*/ React__default.createElement(Slots.Reorder, null)) : null)));
};
LineItemCard.PrescriptionSection = PrescriptionSection;
var LineItemCard$1 = LineItemCard;

export { LineItemCard$1 as default };
//# sourceMappingURL=LineItemCard.js.map
